import { AlertTriangle, CheckCircle2, ShieldAlert } from 'lucide-react';
import type { ConfidenceLevel, VerdictLabel } from '../types/api';
import { VERDICT_TONE, confidenceCopy, verdictCopy } from '../lib/format';

interface VerdictBadgeProps {
  label: VerdictLabel;
  confidence?: ConfidenceLevel | null;
  size?: 'sm' | 'md';
}

const ICONS = {
  good: CheckCircle2,
  mixed: AlertTriangle,
  bad: ShieldAlert,
} as const;

/**
 * Verdict pill.
 *
 * <p>Confidence is shown beside the verdict, never folded into it: a low confidence "Good" must
 * not look like a well evidenced one.
 */
export default function VerdictBadge({ label, confidence, size = 'md' }: VerdictBadgeProps) {
  const tone = VERDICT_TONE[label];
  const Icon = ICONS[tone];

  return (
    <span className="row" style={{ gap: 8 }}>
      <span className={`badge badge--${tone}${size === 'md' ? ' badge--lg' : ''}`}>
        <Icon size={size === 'md' ? 16 : 14} aria-hidden="true" />
        {verdictCopy(label)}
      </span>
      {confidence ? <span className="badge">{confidenceCopy(confidence)}</span> : null}
    </span>
  );
}
